/**
 * Cross-domain session handoff.
 *
 * When a system admin signs in on a firm subdomain they continue on the root
 * domain. The session token never travels in the URL: the subdomain asks the
 * server for a one-time code (valid for a minute), puts the code in the URL,
 * and the root domain redeems it once for the token.
 */
import { projectId } from './supabase/info';

const BASE = `https://${projectId}.supabase.co/functions/v1/make-server-e90c59cd`;

export async function createHandoffCode(sessionToken: string): Promise<string> {
  const res = await fetch(`${BASE}/session/handoff`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${sessionToken}`, 'Content-Type': 'application/json' },
    body: '{}',
  });
  if (!res.ok) throw new Error(`Could not create a handoff code (${res.status})`);
  const { code } = await res.json();
  if (typeof code !== 'string' || !code) throw new Error('Handoff code missing from the response');
  return code;
}

export async function redeemHandoffCode(code: string): Promise<string | null> {
  try {
    const res = await fetch(`${BASE}/session/handoff/redeem`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code }),
    });
    if (!res.ok) return null;
    const { sessionToken } = await res.json();
    return typeof sessionToken === 'string' && sessionToken ? sessionToken : null;
  } catch {
    return null;
  }
}
